import { MdrCompaniesGridWebComponent } from './component/MdrCompaniesGridWebComponent';
import { WEB_COMPONENT_MDR_COMPANIES_GRID } from '../../webcomponents.constants';

export { MdrCompaniesGridWebComponent };

window.customElements.define(WEB_COMPONENT_MDR_COMPANIES_GRID, MdrCompaniesGridWebComponent);
